export default {
  Welcome: 'Welcome',
  WelcomeToYourDashboard: 'Welcome To @:branding.AppName Dashboard.'
}
